<template>
<div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show === true">เปลี่ยนสถานะเรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_delete === true">ลบทีมงานเรียบร้อย</v-alert>
    </v-slide-x-reverse-transition>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div class="mb-2">
            <h2>รายการสมาชิกทีม</h2>
        </div>
        <v-card>
            <v-card-title>
                <v-text-field v-model="search" color="primary" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            </v-card-title>
            <v-data-table :headers="headers" :items="data" :search="search">
                <template v-slot:item="dataDetail">
                    <tr>
                        <td>{{dataDetail.item.number}}</td>
                        <td>{{dataDetail.item.name}}</td>
                        <td>{{dataDetail.item.tel}}</td>
                        <td>
                            <span>
                                <v-switch color="primary" v-model="dataDetail.item.status" @click="changeStatus(dataDetail.item.id)"></v-switch>
                            </span>
                        </td>
                        <td>
                            <span class="edit_data_teamlist" @click="editPage(dataDetail.item.id)">
                                <v-icon right color="grey">mdi-pencil-box-outline</v-icon>
                            </span>
                            <span class="edit_data_teamlist" @click="confirmTeamDelete(dataDetail.item.id,dataDetail.item.name)">
                                <v-icon right color="grey">mdi-delete</v-icon>
                            </span>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
        <v-dialog v-model="open_confirm_delete_team" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    คำเตือน
                </v-card-title>
                <v-card-text>
                    ต้องการลบทีมงาน {{ delete_name }} ใช่หรือไม่ ?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#28ab28" class="white--text" height="50" @click="deleteTeam()">
                        บันทึก
                    </v-btn>
                    <v-btn color="error" height="50" @click="closeConfirmTeamDelete()">
                        ยกเลิก
                    </v-btn>
                </v-card-actions>

            </v-card>
        </v-dialog>
    </div>
</div>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            alert_show: false,
            alert_show_delete: false,
            open_confirm_delete_team:false,
            delete_id: null,
            delete_name: null,
            search: '',
            headers: [{
                    text: 'รหัส',
                    align: 'start',
                    value: 'number',
                },
                {
                    text: 'ชื่อ-สกุล',
                    value: 'name'
                },
                {
                    text: 'เบอร์โทร',
                    value: 'tel'
                },
                {
                    text: 'สถานะ',
                    value: 'status'
                },
                {
                    text: 'จัดการ',
                    value: 'action'
                },
            ],
            data: [],
        }
    },
    methods: {
        async teamList() {
            this.loading_page = true
            this.data = []
            HTTP.get('/team/list-team', {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        response.data.listUser.forEach(detail => {
                            this.data.push({
                                id: detail.id,
                                number: detail.code,
                                name: detail.name,
                                tel: detail.tel,
                                status: detail.status,
                            })
                        })

                        this.loading_page = false
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async changeStatus(id) {
            HTTP.post('/team/status-update', {
                    id: id
                }, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.alert_show = true
                        setTimeout(() => this.alert_show = false, 5000)
                    }

                })
                .catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async editPage(id) {
            const idPage = {
                id: id,
            }
            this.$store.commit('editTeamPage', idPage)
            this.$router.push('/editteam')
        },
        async confirmTeamDelete(id,name){
            this.delete_id = id
            this.delete_name = name
            this.open_confirm_delete_team = true
        },
        async closeConfirmTeamDelete(){
            this.open_confirm_delete_team = false
            this.delete_id = null
            this.delete_name = null
        },
        async deleteTeam() {
            this.loading_page = true
            this.open_confirm_delete_team = false
            HTTP.post('/team/delete/' + this.delete_id, null, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.delete_id = null
                        this.delete_name = null
                        this.teamList()
                        this.alert_show_delete = true
                        setTimeout(() => this.alert_show_delete = false, 5000)
                    }

                })
                .catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        }
    },
    mounted() {
        this.teamList()
    }
}
</script>
